import './Main.scss';

import SliderInit from './General/SwiperInit';
import './General/OptionalMobileSlider/OptionalMobileSlider';
import './General/OptionalDesktopSlider/OptionalDesktopSlider';
import './Content/TeaserCarousel/TeaserCarousel';
import './Content/ImageSlider/ImageSlider';

const sliderInit = new SliderInit();

/**
 * Make sure sliders are destroyed and reinitialized
 * when a new node is created (moving nodes/slides does not seem to be a problem)
 *
 * currently this code is executed whenever ANY node is created, but
 * since this is a hotfix reliability is currently more important
 * than any (possible) performance impact.
 * As long term solution we should find a common identifier for all
 * sliders.
 */
document.addEventListener(
    'Neos.NodeCreated',
    function (event) {
        sliderInit.destroyAllSlider();
        new SliderInit();
    },
    false
);
